angular.module('SpidApp')

.constant('VacationAdapterConfig', {
  name : 'Vacation',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }, {
    	local   : 'id_user',
    	distant : 'user_id'
    }, {
    	local   : 'date_start',
    	distant : 'date_start'
    }, {
    	local   : 'date_end',
    	distant : 'date_end'
    }, {
    	local   : 'amount_start',
    	distant : 'amount_start'
    }, {
    	local   : 'end_state_id',
    	distant : 'end_state_id'
    }, {
    	local   : 'comment',
    	distant : 'comment'
    }, {
    	local   : 'validated',
    	distant : 'validated'
    }, {
    	local   : 'start_transfer',
    	distant : 'start_transfer'
    }, {
    	local   : 'stop_transfer',
    	distant : 'stop_transfer'
    }, {
        local   : 'stop_total',
        distant : 'stop_total'
    }, {
        local   : 'updated_at',
        distant : 'updated_at'
    }
  ]
})
